import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicThemeService {

  constructor() { }

  private currentThemeLink?: HTMLLinkElement;

  loadDispatchTheme() {
    this.loadTheme('assets/styles.css');
  }

  private loadTheme(href: string) {
    this.currentThemeLink = document.createElement('link');
    this.currentThemeLink.rel = 'stylesheet';
    this.currentThemeLink.href = href;
    document.head.appendChild(this.currentThemeLink);
  }

  removeCurrentTheme() {
    if (this.currentThemeLink) {
      document.head.removeChild(this.currentThemeLink);
    }
  }
}
